import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';
import { Loader2 } from 'lucide-react';
import styled from 'styled-components';

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 1.5rem;
    th, td { padding: 0.75rem; text-align: left; border-bottom: 1px solid #e2e8f0; }
    th { background-color: #f8fafc; font-size: 0.9rem; }
    td { font-size: 0.9rem; }
`;

const MemberList = ({ organizationId, keyForRefresh }) => {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);

    // **KLUCZOWA ZMIANA JEST TUTAJ**
    useEffect(() => {
        if (!organizationId) {
            setLoading(false);
            return;
        }
        setLoading(true);
        apiClient.get(`/admin/organizations/${organizationId}/members`)
            .then(res => setMembers(res.data))
            .catch(err => console.error("Błąd ładowania członków organizacji:", err))
            .finally(() => setLoading(false));
    }, [organizationId, keyForRefresh]); // Zależność od stabilnych wartości

    if (loading) return <div style={{textAlign: 'center', padding: '1rem'}}><Loader2 className="icon-spin" /></div>;

    // Nie renderujemy nic, jeśli nie ma ID organizacji
    if (!organizationId) return null;

    return (
        <div style={{marginTop: '1.5rem'}}>
            <h4>Aktualni Członkowie Organizacji</h4>
            <Table>
                <thead>
                <tr>
                    <th>Imię i Nazwisko</th>
                    <th>Rola</th>
                    <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                {members.length > 0 ? members.map(member => (
                    <tr key={member.id}>
                        <td>{member.firstName} {member.lastName}</td>
                        <td>{member.professionalTitle?.replace('ROLE_', '').replace('_', ' ')}</td>
                        <td>{/* Możliwość dodania akcji w przyszłości */}</td>
                    </tr>
                )) : (
                    <tr><td colSpan="3" style={{textAlign: 'center', fontStyle: 'italic', color: '#666'}}>Brak członków w tej organizacji.</td></tr>
                )}
                </tbody>
            </Table>
        </div>
    );
};

export default MemberList;